// Script gating — aktivace blokovaných skriptů/iframů po udělení souhlasu.
//
// Použití na stránce:
//   <script type="text/plain" data-cg="statistics" src="https://.../ga.js"></script>
//   <script type="text/plain" data-cg="marketing">/* inline kód */</script>
//   <iframe data-cg="marketing" data-cg-src="https://youtube.com/embed/..."></iframe>
import type { CategoryId, ConsentState } from './types';

/** Aktivuje všechny blokované prvky, jejichž kategorie je nyní povolená. */
export function applyGating(state: ConsentState): void {
  activateScripts(state);
  activateIframes(state);
}

function activateScripts(state: ConsentState): void {
  const blocked = document.querySelectorAll<HTMLScriptElement>(
    'script[type="text/plain"][data-cg]',
  );
  blocked.forEach((old) => {
    const cat = old.getAttribute('data-cg') as CategoryId | null;
    if (!cat || !state[cat]) return;

    const fresh = document.createElement('script');
    // Přenes atributy kromě řídicích.
    for (const attr of Array.from(old.attributes)) {
      if (attr.name === 'type' || attr.name === 'data-cg') continue;
      fresh.setAttribute(attr.name, attr.value);
    }
    fresh.type = 'text/javascript';
    if (!old.src) fresh.textContent = old.textContent;
    // Označ jako aktivovaný, ať se nespustí podruhé.
    old.setAttribute('data-cg-activated', '');
    old.removeAttribute('data-cg');
    old.parentNode?.insertBefore(fresh, old.nextSibling);
  });
}

function activateIframes(state: ConsentState): void {
  const blocked = document.querySelectorAll<HTMLIFrameElement>(
    'iframe[data-cg][data-cg-src]',
  );
  blocked.forEach((frame) => {
    const cat = frame.getAttribute('data-cg') as CategoryId | null;
    if (!cat || !state[cat]) return;
    const src = frame.getAttribute('data-cg-src');
    if (src) frame.setAttribute('src', src);
    frame.removeAttribute('data-cg');
  });
}
